export enum Environment {
    SANDBOX = 'sandbox',
    PRODUCTION = 'production',
}
